/* Настройки сборки страницы (pay-host, R-2, R-3; web-hosts.md): адрес API, лендинга, сайта документов
 *  и включение целей Метрики задаются по ветке CI, не выводятся из хоста открытой страницы (ADR-015).
 *  CRA подставляет значения REACT_APP_* при сборке; для yarn start - .env.development.
 *  Сборку без ключа останавливает scripts/check-build-env.js; здесь отсутствие ключа - ошибка с его именем. */

export interface IAppSettings {
  apiBaseUrl: string;
  landingUrl: string;
  siteUrl: string;
  metrikaGoals: boolean;
}

/* Обращения к process.env.REACT_APP_* должны быть буквальными: так их находит подстановка сборки. */
const readBuildEnv = () => ({
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_LANDING_URL: process.env.REACT_APP_LANDING_URL,
  REACT_APP_SITE_URL: process.env.REACT_APP_SITE_URL,
  REACT_APP_METRIKA_GOALS: process.env.REACT_APP_METRIKA_GOALS,
});

export type TBuildEnvKey = keyof ReturnType<typeof readBuildEnv>;

export const BUILD_ENV_KEYS = Object.keys(readBuildEnv()) as TBuildEnvKey[];

const requireSetting = (env: ReturnType<typeof readBuildEnv>, key: TBuildEnvKey): string => {
  const value = env[key];

  if (!value) {
    throw new Error(`Build setting ${key} is not set`);
  }

  return value;
};

const withoutTrailingSlash = (url: string) => url.replace(/\/+$/, '');

export const getAppSettings = (): IAppSettings => {
  const env = readBuildEnv();

  return {
    apiBaseUrl: withoutTrailingSlash(requireSetting(env, 'REACT_APP_API_BASE_URL')),
    landingUrl: withoutTrailingSlash(requireSetting(env, 'REACT_APP_LANDING_URL')),
    siteUrl: withoutTrailingSlash(requireSetting(env, 'REACT_APP_SITE_URL')),
    metrikaGoals: requireSetting(env, 'REACT_APP_METRIKA_GOALS') === '1',
  };
};
